import React from 'react'

// material ui
import Box from '@mui/material/Box'

// components
import Typography from '@mui/material/Typography'
import Markdown from 'components/shared/Markdown'

const WaiverText = props => {
  const { title, body, children } = props

  return (
    <Box>
      <Typography align='center' variant='h3' mb={[2, 4]}>
        {title}
      </Typography>
      <Markdown>{body.join('\n\n')}</Markdown>
      {children}
    </Box>
  )
}

export default WaiverText
